import { supabase } from '../lib/supabase';

// Completing a follow-up = logging what happened + clearing the reminder.
// There is deliberately no "done" flag on contacts: done means the interaction
// now lives in the seguimientos timeline (which also bumps last_contact_at via
// trg_seguimientos_update_last_contact) and the reminder date is gone.
// MUST stay in sync with mobile/utils/followups.ts.
export async function completeFollowUp(opts: {
  contactId: string;
  agencyId: string;
  profileId: string;
  note?: string | null;
  /** seguimientos.type; defaults to 'note' (the CRM's "Realizado" button). */
  type?: string | null;
}): Promise<string | null> {
  if (!supabase) return 'Sin conexión';
  const { contactId, agencyId, profileId, note, type } = opts;
  const { error: segError } = await supabase.from('seguimientos').insert({
    contact_id: contactId,
    agency_id: agencyId,
    created_by: profileId,
    type: type || 'note',
    note: note ? `Seguimiento completado: ${note}` : 'Seguimiento completado',
    note_date: new Date().toISOString(),
  });
  if (segError) return segError.message;
  const { error: contactError } = await supabase
    .from('contacts')
    .update({ next_follow_up_at: null, next_follow_up_note: null })
    .eq('id', contactId);
  if (contactError) return contactError.message;
  // Close any open reminder rows so dashboard counts drop now instead of when
  // the 15-min cron fires them. Best-effort: RLS limits this to own rows, and
  // a miss self-heals via run_followup_reminders.
  await supabase
    .from('reminders')
    .update({ is_done: true, done_at: new Date().toISOString() })
    .eq('contact_id', contactId)
    .eq('is_done', false);
  return null;
}

// Move the reminder date, keep the note.
export async function rescheduleFollowUp(contactId: string, when: Date): Promise<string | null> {
  if (!supabase) return 'Sin conexión';
  const { error } = await supabase
    .from('contacts')
    .update({ next_follow_up_at: when.toISOString() })
    .eq('id', contactId);
  return error ? error.message : null;
}

// 09:00 local, `daysAhead` days from today — the snooze targets ("Mañana",
// "+7 días") land on the same 15-min grid the LeadModal reminder editor uses.
export function morningIn(daysAhead: number): Date {
  const d = new Date();
  d.setDate(d.getDate() + daysAhead);
  d.setHours(9, 0, 0, 0);
  return d;
}
